import { lineupApiClient } from '../utils/axios';

import { LineupCardStatus } from '../types/LineupCardStatus';

export const getStatusList = async (date: string): Promise<LineupCardStatus[]> => {
  return (await lineupApiClient.get(`/lineupCard/status?date=${date}`)).data.entity;
};
